import { Paragraph, Wrap } from '@leafwell/components';
import { useWordPressContext } from 'contexts/wordpress-provider';
import { useEventsTracker } from 'contexts/eventsTracker';
import { AlphabeticalGridItem } from './alphabetical-grid-list';
import { AllConditionsResult } from 'lib/queries/conditions';
import dynamic from 'next/dynamic';
const AlphabeticalGridList = dynamic(
  () => import('components/alphabetical-grid-list'),
  { ssr: false },
);

const ConditionsAlphabetical: React.FC<
  AllConditionsResult & {
    variant?: 'default' | 'minimal';
  }
> = ({ variant, conditions }) => {
  const isMinimal = variant === 'minimal';
  const { translations } = useWordPressContext();

  const { trackEvent } = useEventsTracker();
  const handleChangeLetter = (firstLetter: string) => {
    trackEvent({
      event: 'select_content',
      content_type: firstLetter,
      item_id: 'alphabet_letter_filter',
      origin: 'medical_conditions',
    });
  };

  return (
    <>
      <Wrap className="!gap-y-6 pt-0 md:pt-4 lg:pt-0 !pb-0">
        <Paragraph size={isMinimal ? 'small' : 'large'}>
          {translations['Explore A-Z conditions']}
        </Paragraph>
        {!isMinimal && (
          <Paragraph size="small" className="-mt-4">
            {
              translations[
                'Find your condition and click on it to learn all about the most current research and patient stories.'
              ]
            }
          </Paragraph>
        )}
      </Wrap>
      <AlphabeticalGridList
        data={conditions as AlphabeticalGridItem[]}
        className="!pt-4"
        onChangeLetter={handleChangeLetter}
      />
    </>
  );
};

export default ConditionsAlphabetical;
